module.exports = __webpack_public_path__ + "img/typical-drill.f39d183b.svg";